import React, { Fragment, useState } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Button, Grid, IconButton, Menu, MenuItem, Typography, useMediaQuery, Zoom } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { goToAddClient } from '../../../components/ClientEntry/utils';
import { withRouter } from 'react-router';
import { tracking } from '../../../utils/tracking';
import { clientPath } from '../../../utils/client-route';
import './ShortcutsSection.scss';
import { toggleDialog } from '../../../store/control/duck';

const ShortCutButtonStyle = {
  background: '#fff',
  minWidth: 'unset',
  padding: 6
};

const ShortCutButton = props => {
  const { imgSrc, imgAlt, label, onClick } = props;

  return (
    <Grid
      container
      spacing={1}
      wrap="nowrap"
      sx={{
        alignItems: 'center',
        justifyContent: 'flex-start'
      }}
    >
      <Grid>
        <Button variant="contained" color="primary" onClick={onClick} style={ShortCutButtonStyle}>
          <img src={imgSrc} alt={imgAlt} height={32} />
        </Button>
      </Grid>
      <Grid>
        <Typography color="textSecondary">{label}</Typography>
      </Grid>
    </Grid>
  );
};

const ShortcutsSection = props => {
  const { intl, history, toggleDialog, shouldDisableFunctions, openSubscriptionDialog } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const isWide = useMediaQuery(theme => theme.breakpoints.up('sm'));

  const addClient = () => {
    if (shouldDisableFunctions) {
      closeMenu();
      openSubscriptionDialog();
    } else {
      // The form replaces to this on completion (factsheetDetailsForm*'s `done`),
      // so it has to follow the adviser's own client-page choice — hardcoding
      // '/client' dropped an opted-in adviser back onto V1 from this one entry
      // point while every other navigation still went to V2.
      goToAddClient(history, { replaceRoute: clientPath() });
    }
  };

  const getUsers = () => {
    if (shouldDisableFunctions) {
      closeMenu();
      openSubscriptionDialog();
    } else {
      tracking('Click on QR Code - Homepage');
      toggleDialog('myQR', {});
    }
  };

  const policyReview = () => {
    if (shouldDisableFunctions) {
      closeMenu();
      openSubscriptionDialog();
    } else {
      tracking('Click on Policy Review - Homepage');
      history.push('/policy_review');
    }
  };

  const adviserInfoPage = () => {
    if (shouldDisableFunctions) {
      closeMenu();
      openSubscriptionDialog();
    } else {
      tracking('Click on advisers page - Homepage');
      history.push('/profile-plus');
    }
  };

  const usefulCharts = () => {
    if (shouldDisableFunctions) {
      closeMenu();
      openSubscriptionDialog();
    } else {
      tracking('Click on Financial Concept - Main page');
      toggleDialog('financialCharts', {});
    }
  };

  const premiumFinancing = () => {
    if (shouldDisableFunctions) {
      closeMenu();
      openSubscriptionDialog();
    } else {
      tracking('Click on Premium Financing - Main page');
      history.push('/premium_financing');
    }
  };

  const chequeWizard = () => {
    if (shouldDisableFunctions) {
      closeMenu();
      openSubscriptionDialog();
    } else {
      tracking('Click on Cheque Wizard - Main page');
      history.push({ pathname: '/cheque_out' });
    }
  };

  const openMenu = event => setAnchorEl(event.currentTarget);
  const closeMenu = () => setAnchorEl(null);

  const shortcuts = [
    {
      imgSrc: 'img/icons/import_user_active_color.svg',
      imgAlt: 'add',
      label: intl.formatMessage({ id: 'add-client' }),
      onClick: addClient
    },
    {
      imgSrc: 'img/icons/qr_code_active_color.svg',
      imgAlt: 'qr-code',
      label: intl.formatMessage({ id: 'my-qr' }),
      onClick: getUsers
    },
    {
      imgSrc: 'img/icons/policy_review_active_color.svg',
      imgAlt: 'review-pdf',
      label: intl.formatMessage({ id: 'export-sum-desc' }),
      onClick: policyReview
    },
    // {
    //   imgSrc: 'img/adviser-home-page/shortcut_biz.png',
    //   imgAlt: 'my-business-page',
    //   label: intl.formatMessage({ id: 'adviser-info-page' }),
    //   onClick: adviserInfoPage
    // }
    // {
    //   imgSrc: 'img/finConcept.png',
    //   imgAlt: 'useful-charts',
    //   label: intl.formatMessage({ id: 'fin-charts' }),
    //   onClick: usefulCharts
    // },
    // {
    //   imgSrc: 'img/icons/calculator_active_color.svg',
    //   imgAlt: 'premium-financing',
    //   label: intl.formatMessage({ id: 'pfa' }),
    //   onClick: premiumFinancing
    // },
    {
      imgSrc: 'img/icons/cheque_sign_active_color.svg',
      imgAlt: 'cheque-wizard',
      label: intl.formatMessage({ id: 'Cheque Wizard' }),
      onClick: chequeWizard
    }
  ];

  return (
    <Fragment>
      {isWide ? (
        <Grid
          container
          spacing={1}
          sx={{
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          {shortcuts.map((shortcut, index) => (
            <Grid size={6} key={index}>
              <ShortCutButton {...shortcut} />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Fragment>
          <IconButton onClick={openMenu} style={{ width: '100%' }} size="large">
            <MoreVertIcon color="primary" className="client-page-expansion-dot-btn" />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            keepMounted={true}
            open={Boolean(anchorEl)}
            onClose={closeMenu}
            slotProps={{
              list: {
                disablePadding: true
              }
            }}
            slots={{
              transition: Zoom
            }}
          >
            {shortcuts.map((shortcut, index) => (
              <MenuItem onClick={shortcut.onClick} key={index}>
                <Grid
                  container
                  wrap="nowrap"
                  spacing={1}
                  sx={{
                    alignItems: 'center'
                  }}
                >
                  <Grid>
                    <img src={shortcut.imgSrc} alt={shortcut.imgAlt} height={32} />
                  </Grid>
                  <Grid>
                    <Typography>{shortcut.label}</Typography>
                  </Grid>
                </Grid>
              </MenuItem>
            ))}
          </Menu>
        </Fragment>
      )}
    </Fragment>
  );
};

const container = connect(state => ({}), {
  toggleDialog
})(ShortcutsSection);

export default injectIntl(withRouter(container));
